import * as api from '../api';
import * as firebase from '../firebase';

/**
 * Remote/async actions (all of which return a Promise)
 */
export const remote = {
  /**
   * Link user stripe account with provided code from Stripe oauth connection
   *
   * @param {string} code
   * @param {string} stripeState - State used to link account to Stripe with - ex: "test_1569260624388"
   */
  linkStripeAccount(code, stripeState) {
    return firebase.auth.currentUser.getIdToken().then(userToken => {

      const siteId = stripeState.split('_')[0];
      const data = { code, siteId, userToken };

      return api.remote.post('/oauthStripe', data)
        .then(result => {
          console.log('SUCCESSFUL STRIPE CONNECTION!', result);
          return result;
        });
    });
  },
};
